// src/components/ui/JobListing.jsx
//used on the career page
import React from 'react';

const JobListing = ({ job }) => {
  const handleApply = () => {
    // Create email with proper subject line based on job title
    const emailSubject = encodeURIComponent(`Job Application: ${job.title}`);
    const emailAddress = 'info@amvlaw.io';
    
    // Open default email client with pre-filled subject
    window.location.href = `mailto:${emailAddress}?subject=${emailSubject}`;
  };

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-100">
      <div className="p-6">
        <div className="flex flex-wrap justify-between items-start mb-4">
          <h3 className="text-xl font-bold text-gray-900">{job.title}</h3>
          <div className="bg-primary-50 text-primary px-3 py-1 rounded-full text-sm font-medium">
            {job.experience}
          </div>
        </div>
        
        <p className="text-gray-600 mb-4">{job.description}</p>
        
        <div className="mb-4">
          <span className="text-gray-700 font-medium">Location:</span>
          <span className="ml-2 text-gray-600">{job.location}</span>
        </div>
        
        <div className="mb-6">
          <h4 className="text-gray-700 font-medium mb-2">Qualifications:</h4>
          <ul className="list-disc pl-5 space-y-1 text-gray-600">
            {job.qualifications.map((qualification, index) => (
              <li key={index}>{qualification}</li>
            ))}
          </ul>
        </div>
        
        <button 
          onClick={handleApply}
          className="bg-primary hover:bg-primary-dark text-white px-4 py-2 rounded font-medium transition-colors"
        >
          Apply Now
        </button>
      </div>
    </div>
  );
};

export default JobListing;